import React, { useState } from "react";

const DiscoverPage = ({ filter, setUpdateFilter }) => {
  const [enabledBtn, setEnabledBtn] = useState(false);
  const [newFilter, setNewFilter] = useState({});

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setEnabledBtn(true);
    setNewFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setUpdateFilter(newFilter);
    setEnabledBtn(false);
  };

  return (
    <div className="flex flex-wrap gap-4 pt-4">
      {/* MAIN GENRE */}
      <div className="mr-2 flex flex-col">
        {" "}
        <div className="label">
          <span className="label-text pr-2">Huvudgenre</span>
        </div>
        <select
          name="genre_main"
          className="select select-bordered w-30 max-w-xs"
          onChange={handleFilterChange}
          value={newFilter.genre_main}
        >
          <option value="">Välj genre</option>
          {filter &&
            filter.genres_main.map((genre, index) => {
              return (
                <option key={index} value={genre.genre}>
                  {genre.genre}
                </option>
              );
            })}
        </select>
      </div>
      {/* SUB GENRE */}
      <div className="mr-2 flex flex-col">
        {" "}
        <div className="label">
          <span className="label-text pr-2">Undergenre</span>
        </div>
        <select
          name="genre_sub"
          className="select select-bordered w-30 max-w-xs"
          onChange={handleFilterChange}
          value={newFilter.genre_sub}
        >
          <option value="">Välj genre</option>
          {filter &&
            filter.genres_sub.map((genre, index) => {
              return (
                <option key={index} value={genre.slug}>
                  {genre.genre}
                </option>
              );
            })}
        </select>
      </div>
      {/* CONSTELATION */}
      <div className="mr-2 flex flex-col">
        {" "}
        <div className="label">
          <span className="label-text pr-2">Konstellation</span>
        </div>
        <select
          name="constellation_type"
          className="select select-bordered w-30 max-w-xs"
          onChange={handleFilterChange}
          value={newFilter.genre_constellation}
        >
          <option value="">Välj typ</option>
          {filter &&
            filter.constellations.map((constellation, index) => {
              return (
                <option key={index} value={constellation.type}>
                  {constellation.type}
                </option>
              );
            })}
        </select>
      </div>
      {/* SUBMITT BTN */}
      <div className="flex sm:flex-row items-end">
        <button
          type="submit"
          disabled={!enabledBtn}
          onClick={handleSubmit}
          className="btn btn-primary w-full sm:w-auto"
        >
          Filtera
        </button>
      </div>
    </div>
  );
};

export default DiscoverPage;
